import axios from "axios";
import authApi from "./api/authApi";
import shopItemApi from "./api/shopItemApi";
import shopConfigApi from "./api/shopConfigApi";
import strategyGeneratorApi from "./api/strategyGeneratorApi";
import onboardingApi from "./api/onboardingApi";

const api = axios.create({
  // baseURL: process.env.REACT_APP_API_BASE_URL || "https://grok.clk.tukzo.xyz",
   baseURL: process.env.REACT_APP_API_BASE_URL || "https://regx.vocabooks.com",
  // baseURL: "http://localhost:3002",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle token expiration
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Export all API methods
export const { login } = authApi(api);

export const { fetchData, addItem, updateItem, deleteItem, fetchItemById } =
  shopItemApi(api);

export const {
  fetchShopConfigs,
  fetchShopConfigByTemplate,
  addShopConfig,
  updateShopConfig,
  deleteShopConfig,
  getStrategySourceCode,
  testStrategy,
  fetchCounters, // Add this new export
} = shopConfigApi(api);

export const {
  extractOcrText,
  testStrategy: testGeneratorStrategy,
  saveStrategy,
} = strategyGeneratorApi(api);

export const {
  listOnboardingFiles,
  uploadOnboardingFile,
  deleteOnboardingFile,
  downloadOnboardingFile,
  processOnboardingFile,
} = onboardingApi(api);

export default api;
